import VehicleStatus from '@/dossier/constants/VehicleStatus';
import WorkStatus from '@/dossier/constants/WorkStatus';
import { enumValues } from '@/shared/utils/typescript';
import StatusBoardCardItem from '../constants/StatusBoardCardItem';
import StatusBoardGrouping from '../constants/StatusBoardGrouping';

export default class StatusBoardSettings {
  grouping = StatusBoardGrouping.WORK_STATUS;
  workStatuses = enumValues(WorkStatus);
  vehicleStatuses = enumValues(VehicleStatus);
  visibleItems: Array<StatusBoardCardItem> = [];
}